export const donutChartAnimation = true
export const mapDebounceWait = 600; // ms
